import { Backdrop, CircularProgress, Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { ApiError } from "../../Api/ApiError";
import { getStoreData, getStudioList } from "../../Api/Store";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";
import PageTitle from "../atoms/PageTitle";
import StoreDetailCard from "../molecules/StoreDetailCard";
import StoreDetailMenu from "../organisms/StoreDetailMenu";

const StoreDetailPage: React.FC = () => {
    let { storeObjectState, storeObjectDispatch } = React.useContext(StoreObjectStore)
    let { enqueueSnackbar } = useSnackbar()
    const { id } = useParams()
    const [storeId, setStoreId] = React.useState<number>()
    // const [storeData, setStoreData] = React.useState<StoreData>()
    const [loading, setLoading] = React.useState(true)

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const reload = React.useCallback((storeId) => {
        setLoading(true)
        Promise.all([
            getStoreData(storeId, {signal: abortController.signal}),
            getStudioList(storeId, true, {signal: abortController.signal})
        ]).then( values => {
            storeObjectDispatch({type: 'setStoreData', payload: values[0]})
            storeObjectDispatch({type: 'setStudioList', payload: values[1]})
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        }).finally(() => {
            setLoading(false)
        })
    }, [abortController, storeObjectDispatch, enqueueSnackbar])

    /**
     * str_idを数値に変換
     */
    React.useEffect(() => {
        if (id) {
            setStoreId(parseInt(id))
        }
    }, [id])

    /**
     * 店舗データをロード
     */
    React.useEffect(() => {
        if (storeId) {
            reload(storeId)
        }
    }, [storeId, reload])

    return (
        <>
            <PageTitle text={'店舗管理'} />
            {(storeObjectState && storeObjectState.storeData) &&
                <>
                    <Grid container spacing={2} alignItems="stretch">
                        <Grid item xs={12} sm={6} md={4}>
                            <StoreDetailCard
                                storeData={storeObjectState.storeData}
                                enableEdit
                                onEdit={() => {
                                    reload(storeId)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={8} sx={{
                            display: "flex",
                            alignItems: "end"
                        }}>
                            <StoreDetailMenu />
                        </Grid>
                    </Grid>
                    <Outlet />
                </>
            }
            <Backdrop open={loading}><CircularProgress /></Backdrop>

        </>
    )
}

export default StoreDetailPage